import {
  Component,
  OnInit,
  Input,
  Output,
  OnChanges,
  EventEmitter,
} from '@angular/core';
import {
  trigger,
  state,
  style,
  transition,
  animate,
} from '@angular/animations';
import * as $ from 'jquery';
import { Modifier } from './modifier/modifier.class';

@Component({
  selector: 'item-modifier',
  templateUrl: './item-modifier.component.html',
  styleUrls: ['./item-modifier.component.scss'],
  animations: [
    trigger('shakeAnimation', [
      state(
        'start',
        style({
          transform: 'scale(1)',
        })
      ),
      state(
        'end',
        style({
          transform: 'scale(1.6)',
        })
      ),
      transition('start <=> end', animate('200ms ease-in-out')),
    ]),
  ],
})
export class ItemModifierComponent implements OnInit, OnChanges {
  @Input() selectedModifier;
  @Input() selectModifierActive;
  @Input() selectedModifierGroup;
  @Input() selectedModifierMultiple;
  @Input() currentModifierIndex;
  @Input() tooManySelected;
  @Input() tempSelectedModifiers;

  @Output() selectedModifierEvent: EventEmitter<any> = new EventEmitter();
  @Output() deleteTempModifierEvent: EventEmitter<any> = new EventEmitter();

  public tempSelectedModifiersListActive: boolean = false;
  public tempSelectedModifiersListCommentsActive: boolean = false;
  public selectedNumberState: string = 'start';

  constructor() {}

  ngOnInit() {
  }

  ngOnChanges(changes) {
    console.log('changes from the item modifier component', changes);
  }

  public itemModifierNavChange(view:string) {
    if(view === 'modifiers') {
      this.tempSelectedModifiersListActive = false; 
      this.tempSelectedModifiersListCommentsActive = false;

      console.log('MAX', this.selectedModifierGroup.minimum);

      this.selectedModifierGroup._embedded.modifiers.forEach((modifier) => {
        this.tempSelectedModifiers.forEach((tempModifier) => {
          if(tempModifier.id === modifier.id) {
            setTimeout(() => {
              const $selectedEl = $('.item-modifiers').find(`[data-id='${modifier.id}']`);
              $selectedEl.each((index, el) => {
                $(el).addClass('selected');
              })
            }, 100)
          }
        })
      })
    }
    else if (view === 'selected') {
      this.tempSelectedModifiersListActive = true; 
      this.tempSelectedModifiersListCommentsActive = false ;
    }
    else if (view === 'comments') {
      this.tempSelectedModifiersListCommentsActive = true; 
      this.tempSelectedModifiersListActive = false;
    }
  }

  animateNumberState() {
    if (this.selectedNumberState === 'end') {
      this.selectedNumberState = 'start';
      setTimeout(() => {
        this.selectedNumberState = 'end';
      }, 200);
    } else {
      this.selectedNumberState = 'end';
      setTimeout(() => {
        this.selectedNumberState = 'start';
      }, 200);
    }
  }

  /**
   * Function runs when user selects a modifier
   * changes the front end classes, checks for weather its a multiple select or not.
   * @param {$event} object
   * @param {modifier} object
   * @param {multiple} boolean
   */
  selectModifier($event, modifier) {
    let modifiers = $('.modifier');
    let selected = $event.srcElement;

    this.animateNumberState();

        // Check if the max is full
        if(this.selectedModifierGroup.minimum > this.tempSelectedModifiers.length) {
          // Check if multiple
          if(this.selectedModifierMultiple) {
            // Check if already selected
            if (selected.classList.contains('selected')) {
              this.selectedModifierEvent.emit({
                selectedModifier: modifier,
                multiple: true,
                minimum: this.selectedModifierGroup.minimum,
                addModifier: true,
                index: this.currentModifierIndex,
              });
            } else {
              selected.classList.add('selected');
              this.selectedModifierEvent.emit({
                selectedModifier: modifier,
                multiple: true,
                minimum: this.selectedModifierGroup.minimum,
                addModifier: true,
                index: this.currentModifierIndex,
              });
            }
          } else {
            // Checks if modifier should be added or removed
            if (selected.classList.contains('selected')) {
              this.selectedModifierEvent.emit({
                selectedModifier: modifier,
                multiple: false,
                minimum: this.selectedModifierGroup.minimum,
                addModifier: false,
                index: this.currentModifierIndex,
              });
            } else {
              this.selectedModifierEvent.emit({
                selectedModifier: modifier,
                multiple: false,
                minimum: this.selectedModifierGroup.minimum,
                addModifier: true,
                index: this.currentModifierIndex,
              });
            }
            modifiers.each((i, item) => {
              if ($(item).hasClass('selected')) {
                $(item).removeClass('selected');
              } else {
                selected.classList.add('selected');
              }
            });
        }
      } else {
        modifiers.each((i, item) => {
          if ($(item).hasClass('selected')) {
            $(item).removeClass('selected');
          }
        });
        if(this.selectedModifierMultiple) {
          selected.classList.add('selected');
          this.selectedModifierEvent.emit({
            selectedModifier: modifier,
            multiple: true,
            minimum: this.selectedModifierGroup.minimum,
            addModifier: true,
            index: this.currentModifierIndex,
            max: true
          });
        } else {
          selected.classList.add('selected');
          this.selectedModifierEvent.emit({
            selectedModifier: modifier,
            multiple: false,
            minimum: this.selectedModifierGroup.minimum,
            addModifier: true,
            index: this.currentModifierIndex,
            max: true
          });
        }
      }
  }

  public removeTempSelectedModifier(modifier, index) {
    this.deleteTempModifierEvent.emit({ modifier: modifier, index: index });
  }

  public closeSelectModifier() {
    this.selectModifierActive = false;
    console.log('selected modifier', this.selectedModifier);
  }
}



// WEBPACK FOOTER //
// ./src/app/add-to-order/item-modifier/item-modifier.component.ts